import router from '@/router'
import * as $ANTDD from 'dingtalk-jsapi'
import { userLoginApi, wechatLogin } from '../api/user'
import { setLoginUserData } from './access'
import { initSpaceId } from '../api/user'
import { openAuth } from 'dingtalk-design-libs/biz/openAuth'

/**
 * 初始化登录方法
 * @param {Object} authParam
 */
async function appLoginInit(authParam = {}) {
  console.log(authParam, 'authParam')
  // if (!authParam.corpid || !authParam.platform === 'wechat') {
  //   router.replace({
  //     path: '/error'
  //   })
  //   return
  // }
  if (authParam.platform === 'wechat') {
    accountLoginwx(authParam, 'wechat')
  } else {
    $ANTDD.env.platform !== 'notInDingTalk' && dingWebAuth(authParam)
  }
}

// 钉钉网页免登
function dingWebAuth(authParam) {
  try {
    $ANTDD.ready(function() {
      // 当前是钉钉内部网页
      $ANTDD.runtime.permission.requestAuthCode({
        corpId: authParam.corpid,
        onSuccess: function(data) {
          const requestData = {
            code: data.code,
            corpId: authParam.corpid
          }
          accountLogin(requestData, 'dingding', authParam)
        },
        onFail: function(err) {
          // 钉钉授权code失败，稍候重试
          console.log('失败', err)
        }
      }).catch((error) => {
        console.log('登录失败', error)
      })
    }, function(error) {
      console.log('ready-error', error)
    })
  } catch (error) {
    console.log('dingWebAuth', error)
  }
}

const loginAuthApiMap = {
  common: userLoginApi,
  dingding: userLoginApi
}
const loginAuthApiMapWechat = {
  common: wechatLogin,
  wechat: wechatLogin
}

/**
 * 钉钉登录方法
 * @param {Object} data
 * @param {String} platform
 */
async function accountLogin(data, platform, queryData) {
  try {
    const { code, result } = await (loginAuthApiMap[platform] || loginAuthApiMap.common)(data)
    console.log('钉钉data', queryData)
    if (code === 10000) {
      if (result.authFlag && result.authFlag === '1') {
        console.log(345, '')
        openAuth({
          // clientId: 'suiteucfjmnvs86rrmnip', // 测试 应用ID(唯一标识)
          clientId: 'suiteiemieoxxjl3grlti', // 生产 应用ID(唯一标识)
          corpId: queryData.corpid, // 当前组织的corpId
          rpcScope: 'Storage.Space.Write,Storage.Space.Read,Storage.File.Write,Storage.File.Read,Storage.Permission.Read,Storage.Permission.Write,Storage.UploadInfo.Read,Storage.App.Read,Storage.Org.Read,Storage.RecycleBin.Write,Storage.Task.Read',
          fieldScope: '',
          type: 1 // 0 标识授权个人信息；1 标识授权组织信息
        }).then((res) => {
          // 处理返回数据
          console.log(res, 'openAuthres')
          if (res.status === 'ok') {
            var date = {}
            initSpaceId(date).then((data) => {
              console.log(data, 'datainitSpaceId')
            })
          }
        }).catch((err) => {
          console.log('catch______err', err)
          // alert('$ANTDD error: ' + JSON.stringify(err))
        })
      }
    }
    // if (code !== 10000) throw new Error(result)
    return loginSuccess(code, result, queryData)
  } catch (error) {
    // 登录失败
    console.log('登录失败', error)
  }
}
/**
 * 企微登录方法
 * @param {Object} data
 * @param {String} platform
 */
async function accountLoginwx(data, platform, queryData) {
  console.log(data, platform, queryData, '企微登录')
  localStorage.setItem('loginAuthApiWechatVal', JSON.stringify(data))
  try {
    const { code, result } = await (loginAuthApiMapWechat[platform] || loginAuthApiMapWechat.common)(data)
    console.log(code, result, 'code, resultkkkkkkkkkk')
    return loginSuccessWX(code, result, data)
  } catch (error) {
    // 登录失败
    console.log('登录失败', error)
  }
}

/**
 * 企微登录成功
 * @param {Object} result 登录后的用户/版本信息
 * @param {Object} queryData url 携带的参数
 */
function loginSuccessWX(code, result, queryData = {}) {
  console.log(code, result, queryData, '企微44, result')
  try {
    setLoginUserData(result)
    if (code === -10009) {
      router.replace({
        path: '/dueTo',
        query: {
          channel: 'wechat'
        }
      })
      return
    } else if (code === -10010) {
      router.replace({
        path: '/accredit',
        query: {
          channel: 'wechat'
        }
      })
      return
    } else if (queryData.taskId) { // 从消息进入打开侧边栏
      router.replace({
        path: '/Task',
        query: {
          taskId: queryData.taskId,
          nodeId: queryData.nodeId,
          tabkey: queryData.tabkey
        }
      })
    } else if (queryData.meritsId) { // 从绩效消息进入
      localStorage.setItem('meritsId', JSON.stringify(queryData))
      router.replace({
        path: '/son/sonOne'
      })
    } else {
      router.replace({
        path: '/index'
      })
    }
  } catch (error) {
    console.log(error)
  }
}
/**
 * 钉钉登录成功
 * @param {Object} result 登录后的用户/版本信息
 * @param {Object} queryData url 携带的参数
 */
function loginSuccess(code, result, queryData = {}) {
  console.log(queryData, '钉钉登录成功222')
  try {
    setLoginUserData(result)
    if (code === -10009) {
      router.replace({
        path: '/dueTo',
        query: {
          corpId: queryData.corpid,
          channel: 'ding'
        }
      })
      return
    } else if (code === -10010) {
      router.replace({
        path: '/accredit',
        query: {
          corpId: queryData.corpid,
          channel: 'ding'
        }
      })
      return
    } else if (queryData.taskId) {
      router.replace({
        path: '/Task',
        query: {
          taskId: queryData.taskId,
          nodeId: queryData.nodeId,
          tabkey: queryData.tabkey
        }
      })
    } else if (queryData.meritsId) {
      localStorage.setItem('meritsId', JSON.stringify(queryData))
      router.replace({
        path: '/son/sonOne'
      })
    } else if (queryData.id) {
      if (queryData.proTypeId === '2001') {
        router.replace({
          path: '/Projects/ModelTask',
          query: {
            id: queryData.id,
            delFlag: queryData.delFlag
          }
        })
      } else {
        router.replace({
          path: '/Projects/ProjectsTask',
          query: {
            id: queryData.id,
            delFlag: queryData.delFlag
          }
        })
      }
    } else {
      if (code !== 10000) {
        router.replace({
          path: '/loginErr'
        })
      } else {
        router.replace({
          path: '/index'
        })
      }
    }
  } catch (error) {
    console.log(error)
  }
}

function loginSuccessTodo(code, result) {
  console.log(code, result, 'loginSuccessTodo')
  try {
    setLoginUserData(result)
    if (code.code === -10009) {
      router.replace({
        path: '/dueTo'
      })
      return
    } else if (code.code === -10010) {
      router.replace({
        path: '/accredit'
      })
      return
    } else {
      if (code.code !== 10000) {
        router.replace({
          path: '/loginErr'
        })
      }
    }
  } catch (error) {
    console.log(error)
  }
}
export {
  appLoginInit,
  loginSuccess,
  loginSuccessWX,
  loginSuccessTodo
}
